import "./Details.css";

import React, {memo} from "react";

import {PhraseSet} from "features/validationRules/types";
import PhraseSetComponent from "./PhraseSetComponent";

const DocumentPhrasesView = ({docsSet, phrases}: { docsSet: string[], phrases: PhraseSet[] }) => {
    return (
        <>
            {phrases.map((phraseSet, idx) => <PhraseSetComponent key={`${idx}-${phraseSet.phrases.length}-${phraseSet.phrases[0]?.length}`} docsAmount={docsSet.length} phraseSet={phraseSet} idx={idx}/>)}
        </>
    );
};

export default memo(DocumentPhrasesView);
